//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Swiper, SwiperSlide, directive } from 'vue-awesome-swiper'
import { xtLoginJsPath } from '@/config/project-config'
import { Toast} from 'vant';
import demandAddForm from '../modules/demandAddForm'
import md5 from 'js-md5'
export default {
  name: 'header',
  data() {
    let that = this
    return {
      sw:'',
      userInfo: this.$store.getters.getUserInfo, // 登录用户信息
      societyPhone: this.$store.getters['home/getSocietyPhone'] // 获取机构电话号
    };
  },
  created() {

  },
  activated () {
    this.userInfo = this.$store.getters.getUserInfo
  },
  directives: {
  },
  components: {
  },
  destroyed(){
  },
  methods: {
	  toTop() {
	    let top = document.documentElement.scrollTop || document.body.scrollTop;
	    const timeTop = setInterval(() => {
	      document.body.scrollTop = document.documentElement.scrollTop = top -= 50;
	      if (top <= 0) {
	        clearInterval(timeTop);
	      }
	    }, 10);
	  },
	  //跳转至申请加入机构页面
	  fnGotoSignInSociety(e){
	    this.fnStopBub(e);
		if (this.userInfo != null && this.userInfo != undefined && this.userInfo.id != null && this.userInfo.id != '' && this.userInfo.id != undefined) {
			//暂时跳转到：企业中心
			Toast("请去'企业中心->企业信息管理'中申请加入协会");
		}else{
			//暂时跳转到：企业中心
			Toast("请登录后，去'企业中心->企业信息管理'中申请加入协会");
		}
	  },
  },
  mounted() {

  },
  computed: {

  },
  watch: {

  }
};



// WEBPACK FOOTER //
// ./src/pages/societyFloat/societyFloat.vue